import { ChevronRightIcon as ChevronRight } from "@/shared/foundation/icons/mui";

import { SidebarViewType, useWorkspaceSidebar } from "../sidebarContext";

import styles from "./CollapsedSidebar.module.css";

/**
 * Collapsed sidebar that shows a minimal bar with an icon to expand
 */
export function CollapsedSidebar() {
  const sidebar = useWorkspaceSidebar();

  const handleClick = () => {
    sidebar.openView({
      type: SidebarViewType.TabbedSidebar,
      data: undefined,
    });
  };

  return (
    <button
      className={styles.button}
      onClick={handleClick}
      aria-label="Open sidebar"
    >
      <ChevronRight />
    </button>
  );
}
